var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-login h-100"},[_c('router-view'),_c('login-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }